import CrudCustom from '../../../libs/custom/CrudCustom';

let LawanTransaksiService = new CrudCustom('/lawan-transaksis');
export default LawanTransaksiService;
